import {option, Option} from "ts-option";
import {AssetSearchApiDto} from "../../api/model/rest";
import {QuotePartsPriceStrategy} from "../quote/Quote";

export default class AssetSearch {
	constructor(public readonly id: string,
		public readonly manufacturer: Option<string>,
		public readonly model: string,
		public readonly price: number, //in Pounds
		public readonly secondaryPrice: number, //in Pounds
		public readonly attachmentId: Option<string>,
		public readonly categoryId: string,
		public readonly disabled: boolean,
		public readonly markup: number) {}

	static fromJson(json: AssetSearchApiDto): AssetSearch {
		return new AssetSearch(json.id,
			option(json.manufacturer),
			json.model,
			json.price,
			json.secondaryPrice,
			option(json.attachmentId),
			json.categoryId,
			json.disabled,
			json.markup
		);
	}

	/**
	 * Format amount to human readable string, in format £2,500.00
	 */
	formatPrice(quantity: number = 1): string {
		return (this.price * quantity / 100).toLocaleString("en-IE", {style: "currency", currency: "EUR"});
	}

	getDisplayText() {
		return `${this.getDisplayTextWithoutPrice()} ${this.formatPrice()}`
	}

	getDisplayTextWithoutPrice() {
		return `${this.model}${this.manufacturer.map(m => ` (${m})`).getOrElse("")}`
	}

	increasePriceByPercentage(fraction: number) {
		return this.copy(
			{price: (this.price * (1 + (fraction / 100))), secondaryPrice: (this.secondaryPrice * (1 + (fraction / 100)))})
	}

	copy({
		price = this.price,
		secondaryPrice = this.secondaryPrice,
	}) {
		return new AssetSearch(this.id, this.manufacturer, this.model, price, secondaryPrice, this.attachmentId, this.categoryId,
			this.disabled,
			this.markup);
	}

	getPrice(priceStrategy: string) {
		return priceStrategy == QuotePartsPriceStrategy.BEST_AVAILABILITY ? this.price : this.secondaryPrice;
	}
}
